export default __webpack_public_path__ + "static/media/ic_settings_16.92e9e104.svg";